import { axiosAPIUrl, Parameter, assignParams } from "./index";

/**
 * 修改收货地址
 * @param parameter
 */
export function editCompanyAddressInfo(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/cykjoperation/companyManage/modfiyCompanyAddressInfo",
    method: "post",
    data: { ...parameter, ...assignParams() },
  });
}

/**
 * 删除收货地址
 * @param parameter
 */
export function deleteCompanyAddressInfo(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/cykjoperation/companyManage/delCompanyAddressInfo",
    method: "post",
    data: parameter,
  });
}

/**
 * 新增收货地址
 * @param parameter
 */
export function addCompanyAddressInfo(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response>({
    url: "/cykjoperation/companyManage/addCompanyAddressInfo",
    method: "post",
    data: parameter,
  });
}

// 修改手机号获取验证码
export function getSmsCodeByChangeMobile (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjusercenter/usermanagement/web/getSmsCodeByChangeMobile',
    method: 'post',
    data: parameter,
    extraParams: { showToastTip: false },
  })
}

// 修改手机号确认
export function changeMobileConfirm (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjusercenter/usermanagement/web/ChangeMobileConfirm',
    method: 'put',
    data: parameter,
    extraParams: { showToastTip: false },
  })
}

// 绑定新的手机号获取验证码
export function getSmsCodeByBindNewMobile (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjusercenter/usermanagement/web/getSmsCodeByBindNewMobile',
    method: 'post',
    data: parameter,
    extraParams: { showToastTip: false },
  })
}

// 绑定新的手机号确认
export function bindMobile (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjusercenter/usermanagement/web/bindMobile',
    method: 'post',
    data: parameter,
    extraParams: { showToastTip: false },
  })
}

// 修改密码获取验证码
export function getSmsCodeByChangePassword (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjusercenter/usermanagement/web/getSmsCodeByChangePassword',
    method: 'post',
    data: parameter,
    extraParams: { showToastTip: false },
  })
}

// 修改密码确认
export function changePasswordConfirm (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjusercenter/usermanagement/web/changePasswordConfirm',
    method: 'put',
    data: parameter,
    extraParams: { showToastTip: false },
  })
}

// 修改密码
export function changePassword (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjusercenter/usermanagement/web/changePassword',
    method: 'post',
    data: parameter,
    extraParams: { showToastTip: false },
  })
}

// 注销账号
export function removeMobileNew (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjusercenter/usermanagement/web/removeMobileNew',
    method: 'post',
    data: parameter
  })
}